RivalIQ.apps.Favorites.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const PROGRESS_BAR_YES = 1;
    const PROGRESS_BAR_NO = 2;

    const NONE = 'NONE';

    views.Metric = RivalIQ.views.ItemView.mixin({
        className: function () {
            const me = this;

            let className = 'row metric-dropdown-row';

            if (me.model.isSourceAvailable()) {
                // if this is the only available metric in the collection, need to omit
                // the delete button.
                const availableMetrics = me.model.collection.filter(function (metric) {
                    return metric.isSourceAvailable();
                });
                if (availableMetrics.length === 1) {
                    className += ' only-available-metric';
                }
            }

            return className;
        },

        getTemplate: function () {
            const me = this;

            if (!me.getOption('source')) {
                if (me.getOption('showProgressBar')) {
                    return '#favoritesSoloMetricWithProgressBarTemplate';
                }

                return '#favoritesSoloMetricTemplate';
            }

            if (me.getOption('shouldShowSummaryCalculation')) {
                return '#favoritesBuilderMetricWithSummaryCalculationTemplate';
            }

            if (me.getOption('showCustomSummary')) {
                return '#favoritesBuilderMetricWithCustomSummaryTemplate';
            }

            return '#favoritesBuilderMetricTemplate';
        },

        behaviors: {
            AttributeBuilder: {}
        },

        attributes: function () {
            const me = this;
            return {
                'data-id': me.model.cid
            };
        },

        ui: {
            sources: 'select[name=source]',
            timeAnalysisModes: 'select[name=timeAnalysisMode]',
            showProgressBarToggle: 'select[name=showProgressBarToggle]',
            summaryRowMetric: 'select[name=summaryRowMetric]',
            summaryCalculation: 'select[name=summaryCalculation]',
            properties: 'select[name=property]',
            removeBtn: '.x-remove',
            popoverContainer: '.x-popover-container'
        },

        eventsNotToDebounce: {
            'change select[name=source]': 'onSourceChange',
            'change select[name=property]': 'onPropertyChange',
            'change select[name=timeAnalysisMode]': 'onTimeAnalysisModeChange',
            'change select[name=showProgressBarToggle]': 'onShowProgressBarChange',
            'change select[name=summaryRowMetric]': 'onSummaryRowMetricChange',
            'change select[name=summaryCalculation]': 'onSummaryCalculationChange'
        },

        triggers: {
            'click @ui.removeBtn': 'remove'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        initialize: function () {
            const me = this;

            RivalIQ.views.ItemView.prototype.initialize.apply(me, arguments);

            // NOTE rather than re-render when an item is added or removed to
            // the collection we are going to update the class of the element
            // (which is all we actually care about right now). this partially
            // fixes #20167
            const collection = _.get(me, ['model', 'collection']);
            me.listenTo(collection, 'add', me.updateClass);
            me.listenTo(collection, 'remove', me.updateClass);
        },

        updateClass: function () {
            const me = this;
            me.requestRenderedFrame(function () {
                me.el.className = me.className();
            });
        },

        onRemove: function () {
            const me = this;
            me.model.destroy();
        },

        onDestroy: function () {
            $('.popover').popover('hide');
        },

        onShowIntercom: function () {
            if (window.Intercom) {
                window.Intercom('show');
            }
        },

        onRender: function () {
            const me = this;

            if (!me.model.isSourceAvailable()) {

                let message;
                const channel = me.model.get('channel');
                const props = me.getProps();

                // differentiate message based on why the source isn't available.
                if (RivalIQ.props.channelHidden(props, channel)) {
                    message = RivalIQ.strings.favorites_builder_hidden_source_description;
                } else if (!RivalIQ.props.channelSupported(props, channel)) {
                    message = RivalIQ.strings.favorites_builder_no_plan_access_source_description;
                } else {
                    const channelName = (channel ? RivalIQ.data.channels.get(channel).get('name') : RivalIQ.enums.sourceDetails[me.model.getSource()].name);
                    message = RivalIQ.str('favorites_builder_no_token_source_description',
                        channelName,
                        RivalIQ.channels.getOAuthUrl(me.model.getSource()));
                }

                me.$el.popover({
                    content: message,
                    html: true,
                    container: me.ui.popoverContainer,
                    trigger: 'hover',
                    placement: 'auto'
                });

                // need to bind the events like this as the popover element doesn't exist until it's shown.
                me.$el.on('shown.bs.popover', function () {
                    $('a.x-contact-support').on('click', me.onShowIntercom);
                });
                me.$el.on('hidden.bs.popover', function () {
                    $('a.x-contact-support').off('click', me.onShowIntercom);
                });
            }
        },

        serializeData: function () {
            const me = this;
            return _.defaults(me.model.toJSON(), {
                timeAnalysisMode: 0
            });
        },

        validTimeAnalysisModes: function () {
            const me = this;

            return _.intersection(
                me.dashboardModel.getWidget().getValidPropValues('timeAnalysisMode'),
                me.model.validTimeAnalysisModes(me.dashboardModel.baseMetric)
            );
        },

        buildSourceDropdown: function () {
            const me = this;

            const items = me.model.collection.getValidChannels();

            new views.selectors.Source({
                el: me.ui.sources,
                selected: me.model.getSource(),
                disabled: !me.model.isSourceAvailable(),
                items: items?.toJSON()
            }).render();
        },

        buildMetricDropdown: function () {
            const me = this;

            const optgroups = (me.getOption('disableOptgroups') ? null : App.data.metrics.getMetricGroups());

            let value;
            me.ui.properties.selectize({
                placeholder: 'Search metrics',
                selectOnTab: true,
                searchField: 'name',
                valueField: 'index',
                noEmptySelection: true,
                render: {
                    item: metricRender,
                    option: metricRender
                },
                sortField: [
                    {
                        field: 'index',
                        direction: 'asc'
                    },
                    {
                        field: '$score'
                    }
                ],
                optgroups: optgroups,
                lockOptgroupOrder: true,
                wrapperClass: 'riq-select',
                inputClass: 'riq-select-input',
                dropdownClass: 'riq-select-dropdown',
                dropdownContentClass: 'riq-select-dropdown-content',
                onDropdownOpen: function (dropdown) {
                    // NOTE since someone may have clicked the info bubble, be sure to clear any popover
                    const meSelectize = this;
                    meSelectize.$wrapper.find('[data-toggle="popover"]').popover('hide');

                    const selectize = me.ui.properties[0].selectize;
                    value = selectize.getValue();
                    selectize.clear(true);
                },
                onDropdownClose: function () {
                    const selectize = me.ui.properties[0].selectize;
                    if (selectize) {
                        const currentValue = selectize.getValue();
                        if (!currentValue) {
                            selectize.setValue(value, true);
                        }
                    }
                },
                onBeforeItemAdd: function () {
                    // NOTE this event fires just before a selection is set
                    // NOTE destroy the popover, if any, for the item being selected, before it goes away
                    const meSelectize = this;
                    meSelectize.$dropdown.find('[data-toggle="popover"]').popover('destroy');
                },
                onItemAdd: function () {
                    // NOTE this event fires when a selection is set
                    // NOTE reset popovers on the control
                    const meSelectize = this;
                    meSelectize.$wrapper.find('[data-toggle="popover"]').popover();
                }
            });

            me.resetMetricPicker({
                fuzzy: me.getOption('useFuzzyMetricFind')
            });
        },

        getTimeAnalysisModeOptions: function () {
            const me = this;

            const timeAnalysisModes = me.validTimeAnalysisModes();
            if (!timeAnalysisModes.length) {
                return [{
                    id: -1,
                    name: 'N/A'
                }];
            }

            return _.map(timeAnalysisModes, function (mode) {
                const stringKey = `favorites_builder_time_analysis_mode_${mode}_name`;
                const name = RivalIQ.strings[stringKey] || RivalIQ.metric.names.dimensionName('timeAnalysisMode', mode);
                return {
                    id: mode,
                    name: name
                };
            });
        },

        resetTimeAnalysisModePicker: function () {
            const me = this;
            const items = me.getTimeAnalysisModeOptions();
            me.selects.timeAnalysisMode.setItems(items, me.model.get('timeAnalysisMode'));
        },

        buildTimeAnalysisModeDropdown: function () {
            const me = this;

            let items = me.getTimeAnalysisModeOptions();
            if (!me.model.isSourceAvailable()) {
                items = _.filter(items, {
                    id: me.model.get('timeAnalysisMode')
                });
            }
            const select = new RivalIQ.views.Select({
                name: 'timeAnalysisMode',
                el: me.ui.timeAnalysisModes,
                items: items,
                selected: me.model.get('timeAnalysisMode')
            });

            select.render();

            _.set(me, 'selects.timeAnalysisMode', select);
        },

        resetProgressBarPicker: function () {
            const me = this;
            const items = me.getProgressBarOptions();

            // if we've switched to a metric that does not allow progress bars, make sure the model is consistent.
            if (me.model.getShowProgressBar() && !_.find(items, {
                id: PROGRESS_BAR_YES
            })) {
                me.model.setShowProgressBar(false);
            }

            me.selects.showProgressBar.setItems(items, (me.model.getShowProgressBar() ? PROGRESS_BAR_YES : PROGRESS_BAR_NO));
        },

        getProgressBarOptions: function () {
            const me = this;

            const metric = RivalIQ.metric.build(me.dashboardModel.baseMetric, _.clone(me.model.get('metric')));

            const isNumeric = RivalIQ.metric.property.isNumeric(metric);

            if (isNumeric) {
                return [
                    {
                        id: PROGRESS_BAR_YES,
                        name: 'Yes'
                    },
                    {
                        id: PROGRESS_BAR_NO,
                        name: 'No'
                    }
                ];
            } else {
                return [{
                    id: -1,
                    name: 'N/A'
                }];
            }
        },

        buildShowProgressBarDropdown: function () {
            const me = this;

            const select = new RivalIQ.views.Select({
                name: 'showProgressBar',
                el: me.ui.showProgressBarToggle,
                items: me.getProgressBarOptions(),
                selected: (me.model.getShowProgressBar() ? PROGRESS_BAR_YES : PROGRESS_BAR_NO)
            });

            select.render();

            _.set(me, 'selects.showProgressBar', select);
        },

        buildCustomSummaryDropdown: function () {
            const me = this;

            const select = new RivalIQ.views.Select({
                name: 'summaryRowMetric',
                el: me.ui.summaryRowMetric,
                items: me.getCustomSummaryOptions(),
                selected: me.model.getCustomSummary() || NONE
            });

            select.render();

            _.set(me, 'selects.summaryRowMetric', select);
        },

        getCustomSummaryOptions: function () {
            const me = this;

            // For landscape aggregate widgets, the user has to define an aggregation; none is not an option.
            const isLandscapeAggregateWidget = me.dashboardModel.getWidget().isLandscapeAggregateWidget;

            let options = (isLandscapeAggregateWidget ? [] : [{
                id: NONE,
                name: 'None'
            }]);
            options = options.concat(me.model.validCustomSummaryOptions(me.dashboardModel.baseMetric));

            return options;
        },

        resetCustomSummaryDropdown: function () {
            const me = this;

            const items = me.getCustomSummaryOptions();

            if (items.length === 1) {
                me.model.setCustomSummary(null);
            }

            const currentlySelected = me.model.getCustomSummary();
            if (currentlySelected && _.find(items, {
                id: currentlySelected
            })) {
                me.selects.summaryRowMetric.setItems(items, currentlySelected);
            } else {
                me.selects.summaryRowMetric.setItems(items, NONE);
            }
        },

        buildSummaryCalculationDropdown: function () {
            const me = this;

            const items = me.getSummaryCalculationOptions();

            const select = new RivalIQ.views.Select({
                name: 'summaryCalculation',
                el: me.ui.summaryCalculation,
                items: me.getSummaryCalculationOptions(),
                selected: me.model.getCompanyIdAggregate() || items[0]?.id
            });

            select.render();

            _.set(me, 'selects.summaryCalculation', select);
        },

        getSummaryCalculationOptions: function () {
            const me = this;

            const options = me.model.validDimensionAggregationOptions(me.dashboardModel.baseMetric);

            return options;
        },

        resetSummaryCalculationDropdown: function () {
            const me = this;

            const items = me.getSummaryCalculationOptions();

            const currentlySelected = me.model.getCompanyIdAggregate();

            if (currentlySelected && _.find(items, {
                id: currentlySelected
            })) {
                me.selects.summaryCalculation.setItems(items, currentlySelected);
            } else {

                // prefer to default to sum, otherwise average.
                const aggregate = _.find(items, {
                    id: 'companiesSum'
                }) || _.find(items, {
                    id: 'companiesAverage'
                }) || items[0];

                me.model.setCompanyIdAggregate(aggregate?.id);
                me.selects.summaryCalculation.setItems(items, aggregate?.id);
            }
        },

        onAttach: function () {
            const me = this;

            if (me.getOption('source')) {
                me.buildSourceDropdown();
            }

            me.buildMetricDropdown();

            if (me.getOption('timeAnalysisMode')) {
                me.buildTimeAnalysisModeDropdown();
            }

            if (me.getOption('showProgressBar')) {
                me.buildShowProgressBarDropdown();
            }

            if (me.getOption('shouldShowSummaryCalculation')) {
                me.buildSummaryCalculationDropdown();
            }

            if (me.getOption('showCustomSummary')) {
                me.buildCustomSummaryDropdown();
            }
        },

        getMetricSelectOptions: function (source) {
            const me = this;
            const dashboardModel = me.dashboardModel;

            const baseMetric = _.extend({
                source: source
            }, dashboardModel.baseMetric);
            return App.data.metrics.getMetricSelectOptions(dashboardModel, source, me.getProps(), baseMetric, me.getOption('additionalMetrics'));
        },

        resetMetricPicker: function (options) {
            const me = this;
            const source = me.model.getSource();

            me.metricItems = me.getMetricSelectOptions(source);

            let metric = me.model.get('metric');

            if (_.get(options, ['resetMetric'])) {
                // choose default metric as first non-general metric in dropdown list
                const metricGroups = App.data.metrics.getMetricGroups();
                const nonGeneralMetrics = _.reduce(me.metricItems, function (memo, metric) {
                    if (metric.optgroup !== RivalIQ.enums.collection.GENERAL) {
                        memo.push(metric);
                    }
                    return memo;
                }, []);

                // default back to full list if all metrics are general (ie WEB metrics)
                const dropdownOptions = nonGeneralMetrics.length ? nonGeneralMetrics : me.metricItems;
                const optGroups = _.map(metricGroups, 'value');
                const firstMetricSorted = _.sortBy(dropdownOptions, function (metric) {
                    const index = _.indexOf(optGroups, metric.optgroup);
                    return index > 0 && _.indexOf(optGroups, metric.optgroup);
                })[0];

                metric = {
                    property: firstMetricSorted.metric.property,
                    name: firstMetricSorted.name
                };
            }

            // NOTE we don't want to consider name in equality below, so we
            // strip it here in the `haystack` and in the metric `needle` below
            const sanitizedMetrics = _.reduce(me.metricItems, function (memo, metricItem) {
                const itemMetric = _.get(metricItem, ['metric']);
                return memo.concat(_.omit(itemMetric, ['name']));
            }, []);

            // some widgets set `showProgressBar` on the metric; we don't want to look at that since it's not
            // part of the metric definition really.
            const index = _.findIndex(sanitizedMetrics, function (m) {
                const fieldsToOmit = [
                    'name',
                    'source',
                    'channel',
                    'timeAnalysisMode',
                    'showProgressBar',
                    'objectType',
                    'customSummary',
                    'aggregate',
                    'companyIdAggregate'
                ];
                if (!m.dimensions) {
                    fieldsToOmit.push('dimensions');
                }
                const metricForCompare = _.omit(metric, fieldsToOmit);
                if (m.dimensions) {
                    metricForCompare.dimensions = _.without(metricForCompare.dimensions, 'companyId', 'companySetId');
                }

                return RivalIQ.metric.equal(metricForCompare, m, options);
            });

            const selectize = me.ui.properties[0].selectize;

            let value = (_.isUndefined(index) ? -1 : index);

            if (value === -1 && !_.isEmpty(_.omit(metric, ['showProgressBar', 'customSummary', 'companyIdAggregate']))) {
                const deprecatedMetricDef = RivalIQ.metric.build(_.clone(metric),
                    _.defaults({
                        source: source,
                        channel: RivalIQ.data.channels.get(source).getChannel()
                    }, me.dashboardModel.baseMetric), {
                        prependDimensions: true
                    });

                const deprecatedMetricName = RivalIQ.metric.names.metricName(deprecatedMetricDef);
                const deprecationReason = RivalIQ.metric.search.getPropertyValue(deprecatedMetricDef, 'deprecationReason');

                const unselectable = {
                    description: {
                        title: deprecatedMetricName || 'Deprecated',
                        description: deprecationReason || 'This metric is no longer available.'
                    },
                    disabled: false,
                    name: '[Deprecated]',
                    optgroup: RivalIQ.metric.search.getPropertyValue(deprecatedMetricDef, 'collection') || 1,
                    selectable: false
                };
                me.metricItems.splice(0, 0, unselectable);
                value = 0;
                _.each(me.metricItems, function (item, idx) {
                    item.index = idx;
                });
            }

            selectize.reset(me.metricItems, value, true);
            if (me.metricItems.length > 1 && me.model.isSourceAvailable()) {
                selectize.enable();
            } else {
                selectize.disable();
            }

            selectize.$wrapper.find('[data-toggle="popover"]').popover();
        },

        onSourceChange: function () {
            const me = this;
            const source = Number(me.ui.sources.val());

            me.model.setChannel(source, me.dashboardModel.baseMetric);

            // If changing the channel forced a widget type change we will
            // re-render
            if (!me.isDestroyed) {
                me.resetMetricPicker({
                    fuzzy: true,
                    resetMetric: true
                });
                me.resetTimeAnalysisModePicker();
            }

            // reset metric in chart
            me.onPropertyChange();
        },

        onTimeAnalysisModeChange: function () {
            const me = this;

            const timeAnalysisMode = parseInt(me.ui.timeAnalysisModes.val());
            me.model.setTimeAnalysisMode(timeAnalysisMode, me.dashboardModel.baseMetric);

            if (me.getOption('shouldShowSummaryCalculation')) {
                me.resetSummaryCalculationDropdown(); // sums are not valid for delta rels, so make sure we're still good here.
            }

            if (me.getOption('showCustomSummary')) {
                me.resetCustomSummaryDropdown(); // sums are not valid for delta rels, so make sure we're still good here.
            }
        },

        onSummaryRowMetricChange: function () {
            const me = this;

            let customSummary = me.ui.summaryRowMetric.val();
            if (customSummary === NONE) {
                customSummary = null;
            }

            me.model.setCustomSummary(customSummary);
        },

        onSummaryCalculationChange: function () {
            const me = this;

            const customSummary = me.ui.summaryCalculation.val();
            me.model.setCompanyIdAggregate(customSummary);
        },

        onShowProgressBarChange: function () {
            const me = this;

            const showProgressBar = parseInt(me.ui.showProgressBarToggle.val());
            me.model.setShowProgressBar(showProgressBar === PROGRESS_BAR_YES);
        },

        onPropertyChange: function () {
            const me = this;

            // If a metric change resulted in a widget change (e.g., changing sources from cross-channel
            // audience to fb audience means we can't render the pie chart anymore, so we change to table),
            // then me.isRendered will be false (and me.ui.* will still be strings instead of jquery objects).
            if (!me.isRendered) {
                return;
            }

            const metricIndex = parseInt(me.ui.properties.val());
            if (isNaN(metricIndex)) {
                return;
            }
            // let source = me.model.getSource();
            const metric = me.metricItems[metricIndex].metric;

            const isLandscapeAggregateWidget = me.dashboardModel.getWidget()?.isLandscapeAggregateWidget;
            const defaultCustomSummary = (isLandscapeAggregateWidget ? 'all_companies_average' : null);
            me.model.setMetric(metric, me.dashboardModel.baseMetric, defaultCustomSummary);

            // If changing the channel forced a widget type change we will
            // re-render
            if (!me.isDestroyed) {
                if (me.timeAnalysisMode || me.getOption('timeAnalysisMode')) {
                    me.resetTimeAnalysisModePicker();
                }

                if (me.getOption('showProgressBar')) {
                    me.resetProgressBarPicker();
                }

                if (me.getOption('shouldShowSummaryCalculation')) {
                    me.resetSummaryCalculationDropdown();
                }

                if (me.getOption('showCustomSummary')) {
                    me.resetCustomSummaryDropdown();
                }
            }
        }
    });

    function metricRender(item) {
        const metricTemplate = Marionette.TemplateCache.get('#favoritesMetricOptionTemplate');
        return metricTemplate(item);
    }
});
